import { render, staticRenderFns } from "./ParamRemove.vue?vue&type=template&id=907ee878&scoped=true"
import script from "./ParamRemove.vue?vue&type=script&lang=js"
export * from "./ParamRemove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907ee878",
  null
  
)

export default component.exports